

<div>

  <form [formGroup]="profileForm" (ngSubmit)="verifyPatient()">
    <div class="wrapper">
      <div class="container flex-grow-1 overflow-auto" style="margin-top:50px;">

        <div>
          <!--<h5 class="fw-bold text-center mb-4 fw-bold"> Please Confirm Your Date Of Birth To Select A Specialist Provider For Your Referral</h5>-->
          <h5 *ngIf="referralStatus !== 'sent'" class="fw-bold text-center mb-4 fw-bold"> Confirm your date of birth to select a specialist provider</h5>
          <h5 *ngIf="referralStatus == 'sent'" class="fw-bold text-center mb-4 fw-bold"> Confirm your date of birth to print referral letter</h5>
          <p *ngIf="referralStatus !== 'sent' && referralStatus !== 'noSuggestedProvider'" class="text-muted mb-4" style="font-size:19px !important"> After verification, you will choose a specialist from the list provided by your PCP. Once selected, your PCP will send a referral to the specialist. </p>
          <p *ngIf="referralStatus == 'noSuggestedProvider'" class="text-muted mb-4" style="font-size:19px !important"> After verification, you will search for and select the specialist you would like to visit. Once selected, your PCP will send a referral to the chosen specialist. </p>
          <div class="">

            <div class="form-row">

              <div class="col-md-12">
                <div class=" col-md-12 ">
                  <div class=" form-group mb-2 border-bottom fw-bold">
                    <label style="font-size:19px;"> {{'verifypatient.month'|translate}}<span class="text-danger">*</span></label>
                    <div class="position-relative border-0 form-select form-select-custom">
                      <select formControlName="dobMonth" class="form-control text-capitalize border-0" placeholder="Month" (change)="updateDays($event)"  style="font-size:19px !important">
                        <option value="" disabled selected>{{'verifypatient.select_month'|translate}}</option>
                        <option *ngFor="let month of months; let i = index" [value]="i+1">{{ month }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="mb-2">
                    <span id="f-zip-err" class="err"
                          *ngIf="profileForm.controls['dobMonth'].touched && profileForm.controls['dobMonth'].invalid">
                      <span class="err"
                            *ngIf="profileForm.controls['dobMonth'].errors && profileForm.controls['dobMonth'].errors.required">
                        {{'verifypatient.month_error_msg'|translate}}.
                      </span>
                    </span>
                  </div>
                </div>



                <div class=" col-md-12 form-group">
                  <div class=" mb-2 border-bottom fw-bold">
                    <label style="font-size:19px;"> {{'verifypatient.date_label'|translate}}<span class="text-danger">*</span></label>
                    <div class="position-relative pr-3 border-0 form-select form-select-custom">
                      <select formControlName="dobDay" class="form-control text-capitalize border-0"  style="font-size:19px !important">
                        <option value="" selected disabled>{{'verifypatient.select_date'|translate}}</option>
                        <option *ngFor="let day of daysInMonth" [value]="day">{{ day }}</option>
                      </select>

                    </div>
                  </div>
                  <div class="mb-2">
                    <span *ngIf="profileForm.controls['dobDay'].touched && profileForm.controls['dobDay'].invalid">
                      <span class="err"
                            *ngIf="profileForm.controls['dobDay'].errors && profileForm.controls['dobDay'].errors.required">
                        {{'verifypatient.day_error_msg'|translate}}.
                      </span>
                    </span>
                  </div>
                </div>


                <div class=" col-md-12">
                  <div class=" form-group mb-2 border-bottom fw-bold">
                    <label style="font-size:19px;"> {{'verifypatient.year'|translate}}<span class="text-danger">*</span></label>
                    <div class="position-relative pr-3 border-0 form-select form-select-custom">
                      <select formControlName="dobyear" class="form-control text-capitalize border-0" (change)="updateDays($event)"  style="font-size:19px !important">
                        <option value="" disabled selected>{{'verifypatient.select_year'|translate}}</option>
                        <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="mb-2">
                    <span id="f-zip-err" class="err"
                          *ngIf="profileForm.controls['dobyear'].touched && profileForm.controls['dobyear'].invalid">
                      <span class="err"
                            *ngIf="profileForm.controls['dobyear'].errors && profileForm.controls['dobyear'].errors.required">
                        {{'verifypatient.year_error_msg'|translate}}.
                      </span>
                    </span>
                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <footer>

      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-6 col-12" style="padding: 0px 30px 0px 30px">
            <button class="btn btn-primary w-100" type="button" (click)="verifyPatient()">Confirm</button>
          </div>
        </div>
      </div>


    </footer>
  </form>
</div>


<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="invalidLink-model">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong> Invalid Link</strong></h5>
        <p class="mb-0">The link is invalid. Please check the URL and try again.</p>
      </div>
    </div>
  </div>
</div>



<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="incorrectinfo-model">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{'verifypatient.Incorrect_information'|translate}}</strong></h5>
        <h6 class="font-weight-bolder mb-3 ">{{'verifypatient.Credentials_do_not_match_our_records'|translate}}</h6>
        <p class="mb-3">
          {{'verifypatient.Please_check'|translate}}
          <span *ngIf="!getPatientReferralInfo.practicePhone">  {{'verifypatient.office'|translate}}</span>
          <span *ngIf="getPatientReferralInfo.practicePhone">
            {{'verifypatient.at'|translate}} <a href={{phoneLink}}
                                                class="text-info">{{getPatientReferralInfo.practicePhone}}</a>
          </span>    {{'verifypatient.if_you_need_assistance'|translate}}
        </p>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory"
                class="btn btn-primary ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>







